<template>
  <v-container fluid class="errlog-page">
    <AError :api="apiGetErrorLog" />

    <!-- Alert Banner -->
    <AAlertBanner variant="danger" :messages="alertError" title="Warning" :icon-size="22" />

    <!-- Header -->
    <div class="errlog-header">
      <div class="errlog-header__top">
        <div class="errlog-header__info" v-if="!loadingDialog">
          <h1 class="errlog-header__title">{{ model.add.name }}</h1>
        </div>
      </div>
    </div>

    <!-- Filter Section -->
    <div class="section-card">
      <div class="section-header">
        <v-icon color="white" small>mdi-filter-outline</v-icon>
        <span class="section-header__title">Filter</span>
      </div>
      <div class="section-body section-body--form">
        <div class="errlog-filter">
          <div class="errlog-filter__field">
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              :return-value.sync="errorLogDate"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  dense
                  filled
                  v-model="errorLogDate"
                  label="Error Log Date"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  class="errlog-date-field"
                ></v-text-field>
              </template>
              <v-date-picker v-model="errorLogDate" no-title scrollable>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="menu = false">
                  Cancel
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="$refs.menu.save(errorLogDate)"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>
          </div>
          <button class="errlog-generate-btn" @click="getErrorLog()">
            <v-icon size="18" class="mr-2">mdi-file-document-refresh</v-icon>
            Generate
          </button>
        </div>
      </div>
    </div>

    <!-- Data Table Section -->
    <div class="section-card">
      <div class="section-header">
        <v-icon color="white" small>mdi-bug-outline</v-icon>
        <span class="section-header__title">Error Log Results</span>
        <v-spacer></v-spacer>
        <span class="section-header__count">{{ logDatas.length }} records</span>
      </div>
      <div class="section-body section-body--table">
        <v-data-table
          :headers="headers"
          :items="logDatas"
          :items-per-page="10"
          class="errlog-table"
          :footer-props="{
            'items-per-page-options': [10, 25, 50],
          }"
        >
          <!-- Error column -->
          <template v-slot:item.err="{ item }">
            <div class="table-error" v-html="item.err"></div>
          </template>

          <!-- Empty state -->
          <template v-slot:no-data>
            <div class="table-empty">
              <v-icon size="48" color="#cbd5e1">mdi-bug-check-outline</v-icon>
              <span class="table-empty__text">No error logs found for selected date</span>
            </div>
          </template>
        </v-data-table>
      </div>
    </div>

    <v-dialog v-model="loadingDialog" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Loading
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
//BOC:[api]
import Api from "@/objects/api";
//EOC
//BOC:[model]
import Model from "@/objects/model";
//EOC
//BOC:[service]
import Service from "@/objects/service";
//EOC
//BOC:[globalData]
import HrdcData from "@/services/hrdc_event/objects/globalData";
//EOC
//BOC:[mapState]
import { mapState } from "vuex";
//EOC

// import moment from "moment";

export default {
  components: {},
  computed: {
    ...mapState({
      auth: (state) => state.auth.data,
    }),
  },
  props: ["params"],
  emits: ["toggleTaxRatePage"],
  data: () => ({
    //BOC:[apiGetErrorLog]
    apiGetErrorLog: new Api(),
    //EOC
    //BOC:[model]
    model: new Model(),
    //EOC
    //BOC:[service]
    service: new Service(),
    //EOC
    //BOC:[hrdcData]
    hrdcData: new HrdcData(),
    //EOC
    alertError: [],
    errorLogDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    menu: false,
    modal: false,
    formData: {},
    errorField: {
      applicationNo: null,
    },
    loadingDialog: false,
    btnDisabled: false,
    headers: [
      {
        text: "Time",
        align: "start",
        sortable: false,
        value: "time",
      },
      { text: "PID", value: "pid", sortable: false },
      { text: "Hostname", value: "hostname", sortable: false },
      { text: "Error", value: "err", sortable: false },
    ],
    logDatas: [],
  }),
  watch: {
    //
  },
  async created() {
    // this.loadingDialog = !this.loadingDialog;
    this.formData.applicationNo = this.$store.state[this.service.key].data.applicationUuid;
    //BOC:[model]
    this.model.getByKey(this.params.modelKey);
    //EOC
    //BOC:[service]
    if (this.model.serviceKey) this.service.set("key", this.model.serviceKey);
    //EOC

    // Assign apiDetails by mapping repository.
    const apiDetails = {
      apiGetErrorLog: {
        url: `${
          this.$service[this.service.key]
        }/v1/en/console/settings/error_log/get-error-log`,
        method: "get",
      },
    };

    for (const api in apiDetails) {
      if (apiDetails[api].url !== undefined) {
        this[api].setUrl(apiDetails[api].url);
      }
      if (apiDetails[api].method !== undefined) {
        this[api].setMethod(apiDetails[api].method);
      }
      if (apiDetails[api].params !== undefined) {
        this[api].setParams(apiDetails[api].params);
      }
    }

    //EOC
    this.stages = await this.hrdcData.allStages;
    this.rolesAssignation(this.auth.roles);
  },
  mounted() {},
  methods: {
    clearErrorMsg() {
      for (let error in this.errorField) {
        this.errorField[error] = null;
      }
    },
    showErrorMessage(response) {
      for (const key in response.data) {
        this.errorField[key] = null;
        this.errorField[key] = response.data[key];
      }
    },
    redirectBack() {
      let route = this.eventRoute("Settings");
      if (this.params.backTo) {
        route = this.params.backTo;
      }

      this.$router.push({
        name: route,
        params: {
          modelKey: this.model.key,
          backTo: "",
        },
      });
    },
    getErrorLog() {
      this.logDatas = [];

      this.apiGetErrorLog.setQuery(`errorLogDate=${this.errorLogDate}`);
      this.apiGetErrorLog.setCallbackCompleted((response) => {
        try {
          const { status, data } = response;

          if (!status) {
            this.$store.dispatch("showMessage", {
              message: data,
              messageType: "error",
              timeout: 2000,
            });

            return;
          }

          if (status) {
            if (data) {
              for (const item of data) {
                if (item) {
                  const { time, pid, hostname, err } = item;

                  // Prepare error stack details.
                  let errorStack = `
                    <b>type</b>: ${err.type}<br/><br/>
                    <b>message</b>: ${err.message}<br/><br/>
                    <b>stack</b>: ${err.message}<br/>
                  `;

                  this.logDatas.push({
                    time,
                    pid,
                    hostname,
                    err: errorStack,
                  });
                }
              }
            }
          }
        } catch (err) {
          console.log(err);
        }
      });
      this.apiGetErrorLog.fetch();
    },
  },
};
</script>

<style scoped>
/* >>> auto-dark: dark companions for the light rules below. Colours here are
   token references only (--app-*, defined in src/plugins/theme-dark.css) — do
   NOT paste literal hexes back in, and do not regenerate this block from the
   light rules: that is what made the palette drift across 226 files before.
   Hand-written `.dark-mode` rules later in this file still override these. <<< */

.dark-mode .errlog-page {
  background-color: var(--app-page);
}

.dark-mode .errlog-header {
  background: var(--app-elevated);
}

.dark-mode .back-btn {
  background: var(--app-card);
  border: 1px solid var(--app-border-strong);
}

.dark-mode .back-btn:hover {
  background: var(--app-surface);
  border-color: var(--app-border-strong);
}

.dark-mode .section-card {
  background: var(--app-elevated);
}

.dark-mode .section-body {
  background: var(--app-card);
}

.dark-mode .errlog-generate-btn {
  background: var(--app-accent-soft);
}

.dark-mode .errlog-table >>> .v-data-table-header {
  background: var(--app-surface);
}

.dark-mode .errlog-table >>> .v-data-table-header th {
  color: var(--app-text-muted) !important;
  border-bottom: 2px solid var(--app-border) !important;
}

.dark-mode .errlog-table >>> tbody tr:hover {
  background: var(--app-surface) !important;
}

.dark-mode .errlog-table >>> tbody td {
  border-bottom: 1px solid var(--app-border) !important;
  color: var(--app-text);
}

.dark-mode .errlog-table >>> .v-data-footer {
  border-top: 1px solid var(--app-border) !important;
  background: var(--app-surface);
}

.dark-mode .errlog-table >>> .v-data-footer__select {
  color: var(--app-text-muted) !important;
}

.dark-mode .errlog-table >>> .v-data-footer__select .v-input__slot {
  background: var(--app-card) !important;
  border: 1px solid var(--app-border) !important;
}

.dark-mode .errlog-table >>> .v-data-footer__pagination {
  color: var(--app-text-muted) !important;
}

.dark-mode .errlog-table >>> .v-data-footer__icons-before .v-btn,
.dark-mode .errlog-table >>> .v-data-footer__icons-after .v-btn {
  background: var(--app-card) !important;
  border: 1px solid var(--app-border) !important;
}

.dark-mode .errlog-table >>> .v-data-footer__icons-before .v-btn:hover:not(.v-btn--disabled),
.dark-mode .errlog-table >>> .v-data-footer__icons-after .v-btn:hover:not(.v-btn--disabled) {
  background: var(--app-accent-soft) !important;
}

.dark-mode .errlog-table >>> .v-data-footer__icons-before .v-btn .v-icon,
.dark-mode .errlog-table >>> .v-data-footer__icons-after .v-btn .v-icon {
  color: var(--app-text-muted) !important;
}

.dark-mode .table-empty__text {
  color: var(--app-text-faint);
}

/* >>> end auto-dark <<< */

/* ============================================
   PAGE WRAPPER
   ============================================ */
.errlog-page {
  background-color: #d8dce2;
  /* Fills main minus the breadcrumb and footer; a `100vh - 64px` guess only
     subtracts the app bar and overflows. See .layout-main__content. */
  flex: 1 0 auto;
  padding-top: 24px !important;
  padding-bottom: 60px !important;
  font-family: 'Lato', 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif;
}

/* ============================================
   HEADER
   ============================================ */
.errlog-header {
  background: #eaecef;
  border-radius: 16px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.03);
  margin-bottom: 24px;
  overflow: hidden;
}

.errlog-header__top {
  display: flex;
  align-items: center;
  padding: 24px 28px;
}

.back-btn {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border: 1px solid #d1d5db;
  cursor: pointer;
  margin-right: 16px;
  transition: all 0.2s ease;
}

.back-btn:hover {
  background: #f8fafc;
  border-color: #94a3b8;
}

.errlog-header__info {
  flex: 1;
  min-width: 0;
}

.errlog-header__title {
  font-size: 1.2rem;
  font-weight: 700;
  color: #3a3f47;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  letter-spacing: -0.2px;
}

/* ============================================
   SECTION CARDS
   ============================================ */
.section-card {
  background: #eaecef;
  border-radius: 14px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.03);
  overflow: hidden;
  transition: box-shadow 0.3s ease;
  margin-bottom: 24px;
}

.section-card:hover {
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.06);
}

.section-header {
  background: linear-gradient(135deg, #0ea5e9, #38bdf8);
  padding: 13px 20px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.section-header__title {
  color: #ffffff;
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 2px;
  text-transform: uppercase;
}

.section-header__count {
  color: rgba(255, 255, 255, 0.75);
  font-size: 0.72rem;
  font-weight: 500;
}

.section-body {
  background: #fff;
}

.section-body--table {
  padding: 0;
}

.section-body--form {
  padding: 20px 24px;
}

/* ============================================
   FILTER
   ============================================ */
.errlog-filter {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  flex-wrap: wrap;
}

.errlog-filter__field {
  flex: 1;
  min-width: 240px;
  max-width: 400px;
}

.errlog-generate-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 10px 24px;
  border-radius: 12px;
  font-family: 'Lato', sans-serif;
  font-size: 0.85rem;
  font-weight: 700;
  cursor: pointer;
  border: none;
  background: #dbeafe;
  color: #1d4ed8;
  transition: all 0.2s ease;
  margin-top: 2px;
}

.errlog-generate-btn:hover {
  background: #bfdbfe;
  color: #1e40af;
}

/* ============================================
   DATA TABLE
   ============================================ */
.errlog-table {
  background: transparent !important;
  box-shadow: none !important;
}

.errlog-table >>> .v-data-table-header {
  background: #f8fafc;
}

.errlog-table >>> .v-data-table-header th {
  font-family: 'Lato', sans-serif !important;
  font-size: 0.72rem !important;
  font-weight: 700 !important;
  color: #64748b !important;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  border-bottom: 2px solid #e2e8f0 !important;
  padding: 14px 16px !important;
  white-space: nowrap;
}

.errlog-table >>> tbody tr {
  transition: background 0.15s ease;
}

.errlog-table >>> tbody tr:hover {
  background: #f8fafc !important;
}

.errlog-table >>> tbody td {
  font-family: 'Lato', sans-serif !important;
  font-size: 0.85rem !important;
  font-weight: 900 !important;
  padding: 12px 16px !important;
  border-bottom: 1px solid #f1f5f9 !important;
  color: #0f172a;
}

.errlog-table >>> .v-data-footer {
  border-top: 1px solid #e2e8f0 !important;
  font-family: 'Lato', sans-serif !important;
  padding: 12px 20px !important;
  background: #f8fafc;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 8px;
}

.errlog-table >>> .v-data-footer__select {
  font-size: 0.78rem !important;
  color: #64748b !important;
  font-weight: 600;
  margin-right: 16px !important;
}

.errlog-table >>> .v-data-footer__select .v-select {
  font-family: 'Lato', sans-serif !important;
  margin: 0 0 0 8px !important;
}

.errlog-table >>> .v-data-footer__select .v-input__slot {
  background: #fff !important;
  border: 1px solid #e2e8f0 !important;
  border-radius: 8px !important;
  min-height: 32px !important;
  padding: 0 8px !important;
  box-shadow: none !important;
}

.errlog-table >>> .v-data-footer__select .v-input__slot::before,
.errlog-table >>> .v-data-footer__select .v-input__slot::after {
  display: none !important;
}

.errlog-table >>> .v-data-footer__pagination {
  font-size: 0.78rem !important;
  color: #64748b !important;
  font-weight: 600;
  margin: 0 8px !important;
}

.errlog-table >>> .v-data-footer__icons-before,
.errlog-table >>> .v-data-footer__icons-after {
  display: inline-flex;
  gap: 4px;
}

.errlog-table >>> .v-data-footer__icons-before .v-btn,
.errlog-table >>> .v-data-footer__icons-after .v-btn {
  width: 32px !important;
  height: 32px !important;
  background: #fff !important;
  border: 1px solid #e2e8f0 !important;
  border-radius: 8px !important;
  margin: 0 2px !important;
  transition: all 0.15s ease;
}

.errlog-table >>> .v-data-footer__icons-before .v-btn:hover:not(.v-btn--disabled),
.errlog-table >>> .v-data-footer__icons-after .v-btn:hover:not(.v-btn--disabled) {
  background: #e0f2fe !important;
  border-color: #0ea5e9 !important;
}

.errlog-table >>> .v-data-footer__icons-before .v-btn--disabled,
.errlog-table >>> .v-data-footer__icons-after .v-btn--disabled {
  opacity: 0.4 !important;
}

.errlog-table >>> .v-data-footer__icons-before .v-btn .v-icon,
.errlog-table >>> .v-data-footer__icons-after .v-btn .v-icon {
  color: #64748b !important;
  font-size: 18px !important;
}

/* Table cell styles */
.table-error {
  color: #dc2626;
  font-size: 0.82rem;
}

/* Empty state */
.table-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 48px 0;
}

.table-empty__text {
  font-size: 0.88rem;
  color: #94a3b8;
  font-weight: 500;
}

/* ============================================
   TRANSITIONS
   ============================================ */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* ============================================
   RESPONSIVE
   ============================================ */
@media (max-width: 959px) {
  .errlog-header__top {
    padding: 16px 20px;
  }

  .errlog-filter {
    flex-direction: column;
  }

  .errlog-filter__field {
    max-width: 100%;
  }
}

/* ============================================
   DARK MODE
   ============================================ */
.dark-mode .errlog-page { background-color: var(--app-page); }
.dark-mode .errlog-header { background: var(--app-card); }
.dark-mode .errlog-header__title { color: var(--app-text); }
.dark-mode .back-btn { background: var(--app-page); border-color: var(--app-border); }
.dark-mode .back-btn:hover { background: var(--app-card); }
.dark-mode .section-card { background: var(--app-card); }
.dark-mode .section-body { background: var(--app-card); }
.dark-mode .errlog-table >>> .v-data-table-header { background: var(--app-page); }
.dark-mode .errlog-table >>> tbody td { color: var(--app-text) !important; border-color: var(--app-border) !important; }
.dark-mode .errlog-table >>> tbody tr:hover { background: var(--app-border) !important; }
.dark-mode .errlog-table >>> .v-data-footer { background: var(--app-page); border-color: var(--app-border) !important; }
.dark-mode .errlog-generate-btn { background: var(--app-accent-soft); color: var(--app-accent); }
.dark-mode .errlog-generate-btn:hover { background: var(--app-accent-soft); color: var(--app-accent-strong); }
</style>
